/**
 * BlockContentImpl — lazy rendering boundary
 *
 * Default export that renders a single block via the heavy ComponentRenderers
 * switch, falling back to the lightweight fallback renderer for basic/legacy
 * types. This module is loaded via a dynamic import from BlockRenderer so the
 * ~3.2k-line ComponentRenderers module (plus its ~200 styled-components) only
 * ships in a separate chunk that loads when a funnel step actually renders
 * blocks — most storefront page views mount FunnelExperience without an active
 * block layout and never pay for it.
 */

import type { FunnelOffer, StepPageBlock } from '../types';
import { renderComponentBlock, type BlockCallbacks } from './ComponentRenderers';
import { renderFallbackBlock } from './fallback-block-renderer';

export interface BlockContentImplProps {
  block: StepPageBlock;
  offer: FunnelOffer;
  callbacks?: BlockCallbacks;
  offers?: FunnelOffer[];
}

export default function BlockContentImpl({ block, offer, callbacks, offers }: BlockContentImplProps) {
  return renderComponentBlock(block, offer, callbacks, offers) ?? renderFallbackBlock(block, offer);
}
